export default __webpack_public_path__ + "static/media/14.04947af9.jpg";